import { schema } from 'normalizr';

const customFieldsSchema = [new schema.Entity('customFields')];

export {
  // eslint-disable-next-line import/prefer-default-export
  customFieldsSchema,
};
